import { LiveEvent } from 'types/api/media';
import MoreInfoModal, {
  MoreInfoModalTemplateSpec,
} from 'components/common/moreInfoModal/MoreInfoModal';

export interface LiveEventMoreInfoModalTemplateSpec
  extends MoreInfoModalTemplateSpec {
  mediaContent: LiveEvent | undefined;
}

export default class LiveEventMoreInfoModal extends MoreInfoModal<LiveEventMoreInfoModalTemplateSpec> {
  protected get logoSrc() {
    return this._mediaContent?.images.eventLockup ?? '';
  }

  override updateTitle(mediaContent: LiveEvent) {
    const { title } = mediaContent;
    this._Title.patch({ visible: true, text: { text: title } });
    this._Metadata.patch({ flexItem: { marginTop: 0 } });
  }
}
